import { useState, useEffect } from "react";
import "./locationStyle.css";
import LocationSelectionModal from "./LocationSelectionModal";

const LocationsDropdown: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState<{
        state: string;
        city: string | null;
    }>({
        state: "Sélectionner une région",
        city: null
    });

    // Set up an effect to update the selected location when clicking on a city from LocationSelectionModal
    useEffect(() => {
        const handleLocationSelect = (event: CustomEvent) => {
            const { stateName, cityName } = event.detail;

            setSelectedLocation({
                state: stateName || "Sélectionner une région",
                city: cityName || null
            });
        };

        window.addEventListener('locationSelected', handleLocationSelect as EventListener);

        return () => {
            window.removeEventListener('locationSelected', handleLocationSelect as EventListener);
        };
    }, []);

    return (
        <div className="select-container flex-1">
            <button
                className="select-button hover:bg-gray-50 transition-colors w-full"
                onClick={() => setIsModalOpen(true)}
                aria-haspopup="dialog"
            >
                <span className="selected-value">
                    <p className="text-xs md:text-base text-primary-default">
                        {selectedLocation.city
                            ? `${selectedLocation.city}, ${selectedLocation.state}`
                            : selectedLocation.state}
                    </p>
                </span>
                <span className="arrow"></span>
            </button>

            <LocationSelectionModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </div>
    );
};

export default LocationsDropdown;